<div class="mce-dz">
  <swb-dropzone (fileUploaded)="uploaded($event)" [imgOnly]="true"></swb-dropzone>
</div>